var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactiveUserIlls(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 213,
    viewBox: "0 0 222 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9108 132.698C57.9449 151.575 19.1024 135.602 6.39689 170.452C-3.76753 198.331 5.79188 207.963 11.8421 209.294H161.767C128.37 184.9 141.56 152.422 152.329 139.233L136.719 132.698V135.602L127.644 132.698V119.267C131.516 114.306 141.874 100.172 152.329 83.3283C162.784 66.4844 156.685 59.6116 152.329 58.2806C151.966 35.7738 151.24 4.91723 111.671 1.28708C80.0163 -1.61704 66.0523 18.2279 63.0271 28.5134V58.2806C51.1203 62.3464 56.6139 74.9793 60.8491 80.7875L77.9108 108.74C77.9108 116.121 77.9108 131.246 77.9108 132.698ZM77.9108 132.698L94.6418 182.559L102.529 154.166C98.2172 150.398 91.6132 142.137 99.6895 139.233C107.766 136.328 114.832 138.023 117.356 139.233C119.039 141.266 120.827 147.1 114.517 154.166C114.517 156.943 119.985 174.252 122.719 182.559L136.719 137.446",
    stroke: "#FB7C51",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.879 138.939C167.644 128.871 206.068 120.379 217.679 156.372C233.453 205.273 186.762 216.63 162.786 209.373",
    stroke: "#FB7C51",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.88 188.153C169.51 184.455 171.018 180.842 173.571 177.662C176.467 174.056 180.041 170.912 183.258 167.606C186.143 164.641 192.401 160.216 192.902 155.703",
    stroke: "#FB7C51",
    strokeWidth: 2.47855,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197 186.418L164 161.418",
    stroke: "#FB7C51",
    strokeWidth: 2.47855
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7227 58.894C65.8065 61.2128 67.8284 63.6853 70.1542 65.7743C70.8143 66.3671 71.7402 67.1783 71.7497 65.7743C71.7667 63.2529 70.9484 60.7747 70.9021 58.2458C70.8427 55.001 70.8794 51.7442 70.9021 48.4988C70.9191 46.0653 71.1277 43.4503 71.5752 41.0451C71.9055 39.2696 71.8961 37.6115 72.4601 35.8724C72.9952 34.2227 73.0271 32.2829 74.0805 30.8244C75.347 29.0707 76.1419 27.4607 78.0192 26.2874C79.3947 25.4277 80.4758 24.214 81.9579 23.4954C84.4221 22.3006 87.0157 21.4693 89.6484 20.7532C92.051 20.0997 94.8156 19.6657 97.3015 19.4071C99.0802 19.222 100.815 18.7876 102.586 18.6094C105.226 18.3438 107.939 18.5097 110.588 18.5097C115.807 18.5097 121.025 18.5097 126.244 18.5097C127.839 18.5097 129.967 18.1492 131.528 18.5595C133.062 18.9625 134.423 20.5333 135.392 21.6257C137.995 24.5585 139.941 27.8507 141.325 31.5099C143.414 37.0331 144.564 42.8635 145.439 48.6608C145.603 49.7506 146.16 50.9919 146.535 52.0386C146.844 52.8988 147.534 53.3346 147.956 54.0952C148.723 55.4743 148.9 55.0758 150.225 55.3167C151.638 55.5736 152.34 56.6436 153.017 57.7722",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.927 18.5096C132.431 16.145 132.824 14.0581 132.824 11.6418C132.824 10.4162 132.824 9.1905 132.824 7.96484",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1793 73.0352C63.2729 76.1609 68.0542 81.2708 69.2714 84.167",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8574 93.4414C80.0576 97.0248 81.2813 100.508 82.9803 103.886C83.8154 105.546 84.5327 107.586 85.8148 108.971C87.7582 111.07 91.8041 112.35 94.387 113.352C95.7919 113.896 96.9092 114.341 98.235 115.087C100.172 116.176 101.863 116.288 104.007 116.564C108.576 117.151 113.661 117.324 118.248 116.925C120.059 116.767 121.72 115.332 123.385 114.777",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.45 122.816C109.917 122.816 114.383 122.816 118.85 122.816C119.705 122.816 120.131 122.728 120.602 123.434",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M145.339 61.9023C145.339 72.1193 147.189 83.4154 141.628 92.5148",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M149.977 72.7257C152.966 70.0147 152.45 72.8318 152.45 75.4056C152.45 78.5529 151.178 81.0037 149.977 83.8575",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M123.075 115.088C125.671 114.241 127.476 113.818 129.397 111.996C130.119 111.311 131.028 110.847 131.733 110.141C132.328 109.546 132.41 108.812 132.833 108.148C133.473 107.142 134.09 106.571 134.516 105.399C134.812 104.587 136.417 103.937 136.921 103.029C137.912 101.245 139.597 99.1828 140.048 97.1537C140.338 95.8481 140.179 94.8145 140.855 93.5977C141.315 92.7708 141.937 91.5841 141.937 90.6602",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8027 181.766L99.9837 208.849H114.812L122.709 182.14",
    stroke: "#FB7C51",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.495 153.207C103.813 154.756 106.114 156.68 109.006 156.824C110.862 156.916 112.391 156.461 113.841 155.32",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8613 164.672C105.785 164.838 110.824 164.982 116.748 165.148",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4814 176.441C104.687 178.257 112.511 178.102 119.903 178.102",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9834 190.059C104.413 190.388 111.838 190.688 119.275 190.723",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6055 201.954C103.779 201.954 107.953 201.954 112.126 201.954C113.306 201.954 115.98 202.202 117.025 201.68",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7055 47.3665C93.7691 46.3141 92.1511 45.9805 89.8117 45.9805C88.7114 45.9805 81.7924 46.9497 80.8154 47.3663",
    stroke: "#FB7C51",
    strokeWidth: 1.77504,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5587 54.0815C88.2289 54.7408 87.8574 56.0804 89.3387 56.0219C89.9462 55.9979 89.7288 55.0837 89.7288 54.7745",
    stroke: "#FB7C51",
    strokeWidth: 1.77504,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M121.348 48.0169C123.225 46.9967 124.794 46.6733 127.062 46.6733C128.128 46.6733 134.835 47.6129 135.782 48.0167",
    stroke: "#FB7C51",
    strokeWidth: 2.0994,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.276 54.5269C128.596 55.1659 128.956 56.4645 127.52 56.4078C126.931 56.3845 127.142 55.4983 127.142 55.1986",
    stroke: "#FB7C51",
    strokeWidth: 2.0994,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110.394 62.8379C109.794 68.1558 104.454 71.4526 103.588 76.6517C103.212 78.908 105.307 80.4171 107.421 80.7357C108.547 80.9053 109.701 80.8558 110.835 80.8558C111.906 80.8558 113.228 81.0653 114.178 80.4955",
    stroke: "#FB7C51",
    strokeWidth: 1.64,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M120.766 93.4396C118.831 92.7187 116.895 91.9977 114.96 91.2767C113.791 90.8413 112.651 90.4001 111.395 90.3503C108.966 90.254 106.849 91.1504 104.64 91.9403C102.894 92.5643 100.424 92.9319 99.1156 94.267",
    stroke: "#FB7C51",
    strokeWidth: 1.64,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactiveUserIlls);
export default __webpack_public_path__ + "static/media/deactiveUserIlls.43d97f5cd9dbdd577e5b0fe33cceb3d1.svg";
export { ForwardRef as ReactComponent };